import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-advertising-details',
  templateUrl: './help-amazon-advertising-details.component.html'
})
export class HelpAmazonAdvertisingDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
